import { Controller } from '@hotwired/stimulus';
import { convertToCurrency } from './currency';

export default class extends Controller {
  static targets = ['amount', 'fees', 'total'];

  connect() {
    this.#render(0, 0);
  }

  update(event) {
    this.#render(event.detail.amount, event.detail.commissionRate);
  }

  #render(amount, commissionRate) {
    const netAmount = commissionRate > 0 ? Math.round(amount / (1 + commissionRate / 100)) : amount;
    const fees = amount - netAmount;

    this.amountTarget.textContent = convertToCurrency(netAmount);
    this.feesTarget.textContent = convertToCurrency(fees);
    this.totalTarget.textContent = convertToCurrency(amount);
  }
}
